/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class PostTypeIcon extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            propTypeIcons: {
                status: 'fa fa-align-left',
                link: 'fa fa-link',
                media: 'fa fa-camera',
                video: 'fa fa-play-circle-o'
            }
        };

    }

    render() {
        return (
            <div className="post-type-overlay queue-post-type-overlay">
                <i className={this.state.propTypeIcons[this.props.postType]}></i>
            </div>
        );
    }

};

PostTypeIcon.propTypes = {
    item: PropTypes.object
};

PostTypeIcon.defaultProps = {
    item: {}
};

export default PostTypeIcon;
